import { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import CompanyComponent from "../components/CompanyComponent";
import franchiseIcon from "../../../assets/design-revamp-company/franchise-component/franchise-icon.svg";
import {
  updateFranchise,
  getFranchise,
  deleteFranchise,
} from "../../../apis/Business/FranchiseApi";
import Franchise from "../Franchise";
import { AlertV2 } from "../../../components/Alert";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import CompanyTabsBar from "../../Company/CompanyTabsBar";
import { upsertCompanyTab } from "../../Company/useCompanyOpenTabs";

const EditFranchise = () => {
  const { t } = useTranslation();
  const { franchiseId } = useParams();
  const urlParams = new URLSearchParams(window.location.search);
  const year = urlParams.get("year");
  const [franchiseName, setFranchiseName] = useState("");
  const [franchiseHolder, setFranchiseHolder] = useState("");
  const [vatNumber, setVatNumber] = useState("");
  const [countryOrigin, setCountryOrigin] = useState("");
  const [scope1, setScope1] = useState("");
  const [scope2, setScope2] = useState("");
  const [errorMessage, setErrorMessage] = useState({});
  const [deleteFacilityAlert, setDeleteFacilityAlert] = useState(false);
  const [cutOffAddress, setCutOffAddress] = useState("");
  const navigate = useNavigate();
  const [isDataLoaded, setIsDataLoaded] = useState(false);

  useEffect(() => {
    if (year == null || year === "") {
      navigate("/company");
    }
  }, [navigate, year]);

  const handleFormDataChange = (updatedFormData) => {
    setFranchiseName(updatedFormData.franchiseName);
    setFranchiseHolder(updatedFormData.franchiseHolder);
    setVatNumber(updatedFormData.vatNumber);
    setCountryOrigin(updatedFormData.countryOrigin);
    setScope1(updatedFormData.scope1);
    setScope2(updatedFormData.scope2);
  };

  const handleMove = useCallback(
    () => navigate("/company", { replace: true }),
    [navigate]
  );

  const save = () => {
    updateFranchise({
      objectId: franchiseId,
      name: franchiseName,
      franchise_holder: franchiseHolder,
      vat_num: vatNumber,
      country: countryOrigin,
      setErrorMessage: setErrorMessage,
      scope_1: scope1,
      scope_2: scope2,
      use_swal: true,
      callback: () =>
        setTimeout(() => {
          window.location.reload();
        }, 1000),
    });
  };

  const handleDelete = () => {
    setDeleteFacilityAlert(true);
  };

  useEffect(() => {
    getFranchise({
      objectId: franchiseId,
      setFranchiseName: setFranchiseName,
      setFranchiseHolder: setFranchiseHolder,
      setVatNumber: setVatNumber,
      setCountryOrigin: setCountryOrigin,
      setScope1: setScope1,
      setScope2: setScope2,
      setIsDataLoaded: setIsDataLoaded,
    });
  }, [franchiseId]);

  useEffect(() => {
    if (!franchiseId) return;
    if (!franchiseName) return;
    upsertCompanyTab({
      id: `franchise-${franchiseId}`,
      name: franchiseName,
      kind: "franchise",
      to: `/company/franchise/${franchiseId}?year=${encodeURIComponent(year || "")}`,
    });
  }, [franchiseId, franchiseName, year]);

  const handleSave = () => {
    save();
    return;
  };

  return (
    <>
      <CompanyTabsBar activeTabId={`franchise-${franchiseId}`} />
      <div
        className="companydetail"
        style={{
          display: "flex",
          flexDirection: "row",
          paddingRight: "42px",
          marginTop: "20px",
        }}
        id="franchise-id"
      >
        <CompanyComponent
          name={franchiseName}
          address_line_1={cutOffAddress !== "" ? cutOffAddress : countryOrigin}
          iconComponent={franchiseIcon}
        />
        {isDataLoaded && (
          <Franchise
            initialData={{
              franchiseName,
              franchiseHolder,
              vatNumber,
              countryOrigin,
              scope1,
              scope2,
            }}
            isNewFacility={false}
            onFormDataChange={handleFormDataChange}
            handleSave={handleSave}
            errorMessage={errorMessage}
            setCurrentName={setFranchiseName}
            setCutOffAddress={setCutOffAddress}
            handleDelete={handleDelete}
          />
        )}
      </div>
      <AlertV2
        open={deleteFacilityAlert}
        title={t("DELETE_FACILITY_2")}
        accept={() => {
          deleteFranchise({ objectId: franchiseId });
          handleMove();
        }}
        decline={() => setDeleteFacilityAlert(false)}
      />
    </>
  );
};

export default EditFranchise;
